export type MeetingEntranceRequest = {
    roomId: string;
}

export type SessionSettingsResponse = {
    isTherapistUser: boolean;
    isRoomModerator: boolean;
    isUserInMeeting: boolean;
    canAccessRoom: boolean;
    isTheRoomFull: boolean;
    userHasCredits: boolean;
    entryApproved: boolean;
    sessionRole: 'terapeuta' | 'paciente' | 'participant';
    dyteMeetingAlreadyExists: boolean;
    /** Sala marcada para testes em DEV — permite entrar sem moderador ter iniciado antes. */
    devTestOpen?: boolean;
}

export enum AccessRoomResponseOptions {
    APPROVE = "approve",
    DENY = "deny",
}

export enum AccessRoomResponseStatus {
    PENDING = "pending",
    APPROVED = "approved",
    DENIED = "denied",
}

export type RoomAccessRequestStatus = AccessRoomResponseStatus.PENDING | AccessRoomResponseStatus.APPROVED | AccessRoomResponseStatus.DENIED;

export type RoomAccessRequest = {
    id: string;
    userId: string;
    status: RoomAccessRequestStatus;
    name?: string | null;
    email?: string | null;
    role?: string | null;
    sessionIdentityKey?: string | null;
    requestedAt?: Date | null;
};

